export const EXAMPLE_QUESTIONS = [
  {
    title: "Search papers",
    examples: [
      "Summarize the PubMed papers of the last 5 years that dealt with the connection between [protein/gene name] and [disease name].",
      "Please summarize the core hypotheses, experimental methods, results summary and limitations of this paper (PMID: 12345678).",
      "Please compare and analyze the reliable research among the papers including [Keyword 1] and [Keyword 2].",
      "Please summarize only the [keyword] related review papers that were recently published [as of the year].",
    ],
  },
  {
    title: "Experimental design",
    examples: [
      "How should I design an omics-based experiment to identify changes in the expression of [protein/pathogen name] related to [disease name]?",
      "What conditions or control design would be required to verify this [hypothesis] with experiments?",
      "Please suggest whether meaningful statistical results can be expected with the number of samples (n=18) currently secured, along with the analysis method.",
      "What areas should be supplemented to design a new experiment based on the results of the previous [Job_1234] analysis?",
    ],
  },
  {
    title: "Interpretation of results",
    examples: [
      "[File upload, Job selection] Summarize the main biological pathway and its functional implications associated with this protein expression list.",
      "[File upload, Job selection] Please let me know the link between the following protein sets and diseases. If you have any evidence or reviews, please present them together.",
      "[File upload, Job selection] Visualize this interaction network between protein groups, identify key hub proteins.",
      "[File upload, Job selection] Please suggest a biomarker candidate for validation or follow-up experiment idea based on protein expression results.",
    ],
  },
  {
    title: "Smart prompt",
    examples: [
      "Based on the results of the last three analyses, please organize the proteins that have emerged in common and also give me a summary of the functions of each protein.",
      "[Disease Name] Please update the relevant biomarker recommendation list periodically. Let me know if you have any new papers.",
      "Please automatically generate a summary report based on the last analysis flow. Including the title, main result, interpretation, and reference paper.",
      "Please summarize the difference of this condition compared to the experimental conditions used in the previous analysis.",
    ],
  },
];
